<template>
    <div class="profile">
        <div class="tabs-content">
            <div class="container">
                <h3 class="heading" v-bind:style="{ color: getCorpHeadingColor } ">
                    <br/>
                    <br/><span>All Related Videos</span>
                </h3>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="container">
                        <div class="tabContent" id="tabs-1" :class="{ current: true }">
                            <div class="">
                                <div class="row yourFaves" v-if="getAuthRecommendedVideos">
                                    <div class="col-md-12">
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" v-for = "video in getAuthRecommendedVideos">
                                        <a :href="'/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                        <img class="jw-img" :src="video.image" />
                                        <p> <i class="fa fa-play-circle-o"></i> {{video.title}}</p>
                                        </a>
                                        <hr>
                                        <div class="plusicon btn-group">
                                            <button title="Add to Playlist" :id="video.mediaid" type="button" @click="showPlaylistMenu(video.mediaid)" class="dropdown-toggle ellipsis pull-right">
<!--                                                <img src="../assets/playlist-icon.png" class="menuiconbutton"/>-->
                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                     width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
<rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                    <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                    <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
</svg>
                                            </button>
                                            <ul class="hide">
                                                <li  v-if="getUserPlaylists">
                                                    <label>
                                                        <b> Add to ...</b>
                                                    </label>
                                                </li>
                                                <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                    <label class="notificationwithcheckboxes">
                                                        <input type="checkbox" :checked="verifyVideoExists(playlist, video)" @click="setPlaylistVideoStatus(video, playlist, verifyVideoExists(playlist, video)) "/> {{playlist.title}}
                                                        <transition name="fade">
                                                            <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                            <span class="added" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                        </transition>
                                                        <transition name="fade">
                                                            <span class="removed" v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                        </transition>
                                                    </label>
                                                </li>
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Second option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Third option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <!--<li>-->
                                                <!--<label>-->
                                                <!--<input type="checkbox" /> Forth option-->
                                                <!--</label>-->
                                                <!--</li>-->
                                                <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                <li><label style="color:#f0617d">Create new playlist</label></li>
                                                <li><label>  <input type="text" class="form-control" v-model="newPlaylistName" />
                                                    <i class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                </label> </li>
                                            </ul>
                                            <div class="backdropformenu"  @click="hidePlaylistMenu(video.mediaid)"></div>
                                        </div>
                                        <p class="right-heart-icon">
                                            <a href="javascript:" @click="setVideoStatus(video)" title ="Liked this video?">
                                                <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                   v-bind:class="{'activeIcons': getVideoStatus(video)}" aria-hidden="true" ></i></a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {input, checkbox, buttonGroup, spinner} from 'vue-strap'
    import $ from 'jquery'
    export default {
        spinner: false,
        components: {
            'bs-input': input,
            'checkbox': checkbox,
            'button-group': buttonGroup,
            'spinner': spinner,
            alert
        },
        name: 'profile',
        data: function () {
            return {
                interestIndexes: [],
                userInterests: [],
                spinner: false,
                newPlaylistName: '',
                tabs: {
                    videos: true,
                    chat: false,
                    discussion: false
                },
                videoAdded: false,
                videoRemoved: false,
                selectedVideo: 0,
                selecedPlaylist: 0
            }
        },
        methods: {
            switchTab: function (id) {
                for (let tab in this.tabs) {
                    this.tabs[tab] = id === tab
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            getInterestStatus (interest) {
                if (this.getUserInterests) {
                    let selectedInterestId
                    console.log(selectedInterestId)
                    let exists = this.getUserInterests.filter(selectedInterestId => {
                        return selectedInterestId.interestId === interest.interestId
                    })
                    if (exists && exists.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setVideoPlayerObject (videoCode) {
                this.$router.push(`/watch/${videoCode}`)
            },
            getVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0 && exists[0].liked === '1') {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            setVideoStatus (videoObject) {
                if (this.getAuthUserVideos) {
                    let mediaId = videoObject.mediaid
                    let exists = this.getAuthUserVideos.filter(videoObject => {
                        return videoObject.videoCode === mediaId
                    })
                    if (exists && exists.length > 0) {
                        if (exists[0].liked === '1') {
                            exists[0].liked = '0'
                        } else {
                            exists[0].liked = '1'
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    } else {
                        let logWatchedEntry = {
                            videoCode: videoObject.mediaid,
                            userId: this.user.userId,
                            playlistId: null,
                            playlistCode: null,
                            watched: 'N',
                            rating: null,
                            liked: '1',
                            durationWatched: 0,
                            thumbnailURL: null,
                            opinion: null
                        }
                        this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                        })
                    }
                }
            },
            setPlaylistVideoStatus (video, playlist, currentStatus) {
                let self = this
                self.selectedVideo = video.mediaid
                self.selectedPlaylist = playlist.playlistId
                if (currentStatus) { // Video is unSelected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userPlaylistId = playlist.playlistId
                    payload.userId = this.user.userId
                    this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                        self.videoAdded = false
                        self.videoRemoved = true
                    })
                } else { // Video is Selected
                    let payload = {}
                    payload.videoCode = video.mediaid
                    payload.userId = this.user.userId
                    payload.userPlaylistId = playlist.playlistId
                    this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                        // this.charities = this.getAuthUserVideos
                        self.videoAdded = true
                        self.videoRemoved = false
                    })
                }
                setTimeout(() => {
                    self.videoAdded = false
                    self.videoRemoved = false
                }, 1500)
            },
            verifyPlaylistExists () {
                if (this.getUserPlaylists) {
                    let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                        return x.userPlaylistVideos !== null
                    })
                    if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            verifyVideoExists (playlist, video) {
                let self = this
                if (this.getUserPlaylists) {
                    let findPlaylist = this.getUserPlaylists.filter(x => {
                        return x.playlistId === playlist.playlistId
                    })
                    if (findPlaylist && findPlaylist.length > 0) {
                        if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                            let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                                return x.videoCode === video.mediaid
                            })
                            if (videos && videos.length > 0) {
                                self.playlistHasVideo = true
                                return true
                            } else {
                                return false
                            }
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            addNewPlayList () {
                if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                    let payload = {}
                    payload.userId = this.user.userId
                    payload.title = this.newPlaylistName
                    this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                        this.newPlaylistName = ''
                        // this.charities = this.getAuthUserVideos
                    })
                }
            },
            showPlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            },
            hidePlaylistMenu (videoCode) {
                // console.log(videoCode)
                $('#' + videoCode + ' + ul').toggleClass('hide')
            }
        },
        computed: {
            ...mapGetters([
                'getAuthRecommendedVideos', 'user', 'error', 'getAuthUserVideos', 'getUserPlaylists', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
            ])
        },
        mounted () {
            this.$store.dispatch('GETAUTHRECOMMENDEDVIDEOS', this.user.userId).then(() => {
            })
            // Get User Liked Videos
            this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId).then(() => {
                // this.charities = this.getAuthUserVideos
            })
            this.$store.dispatch('GETUSERPLAYLISTS', this.user.userId).then(() => {
                // this.charities = this.getAuthUserVideos
            })
        }
    }
</script>
<style scoped>
    .btn-group.plusicon {
        position: absolute;
        right: 50px;
        bottom: 0px;
        height: 29px;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right{
        font-size: 21px;
        top: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right li label{
        padding: 30px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 15px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size:24px;
        right:20px;
        cursor: pointer;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul{
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    .profile .tabContent .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        left: auto ;
        right: 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }
</style>




// WEBPACK FOOTER //
// RelatedVideo.vue?b48df3aa